var _path, _path2, _g, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHourglass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9 1.5H6.76663V6.56667C6.76663 8.47428 7.82085 10.1357 9.37848 11C7.82084 11.8643 6.7666 13.5257 6.7666 15.4333L6.7666 20.5H16.8999V15.4333C16.8999 13.5257 15.8457 11.8643 14.2881 11C15.8457 10.1357 16.9 8.47429 16.9 6.56667V1.5Z",
    fill: "#8D33FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_42_2110",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 1,
    width: 11,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9 1.5H6.76663V6.56667C6.76663 8.47428 7.82085 10.1357 9.37848 11C7.82084 11.8643 6.7666 13.5257 6.7666 15.4333L6.7666 20.5H16.8999V15.4333C16.8999 13.5257 15.8457 11.8643 14.2881 11C15.8457 10.1357 16.9 8.47429 16.9 6.56667V1.5Z",
    fill: "#731DE0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_42_2110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6332 11.0002H8.66658L7.39991 10.5779C7.04806 9.59272 6.4288 7.74902 6.76658 8.25569C7.1888 8.88902 9.51102 9.10023 12.4666 8.04467C14.831 7.20023 16.5481 7.9743 17.111 8.46689L15.6332 11.0002Z",
    fill: "#FF8833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.32458 19.6557H16.1839L17.9765 19.0669C18.4745 17.6933 19.3508 15.1229 18.8728 15.8293C18.2753 16.7122 14.9888 17.0067 10.8061 15.5351C7.4599 14.3577 5.02992 15.437 4.23321 16.1237L6.32458 19.6557Z",
    fill: "#FF8833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.411 12.2666C11.411 12.6164 11.1274 12.9 10.7776 12.9C10.4278 12.9 10.1443 12.6164 10.1443 12.2666C10.1443 11.9169 10.4278 11.6333 10.7776 11.6333C11.1274 11.6333 11.411 11.9169 11.411 12.2666Z",
    fill: "#FF8833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5222 14.3777C13.5222 14.7275 13.2386 15.0111 12.8888 15.0111C12.539 15.0111 12.2555 14.7275 12.2555 14.3777C12.2555 14.0279 12.539 13.7444 12.8888 13.7444C13.2386 13.7444 13.5222 14.0279 13.5222 14.3777Z",
    fill: "#FF8833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8333 15.6446C11.8333 15.9943 11.5498 16.2779 11.2 16.2779C10.8502 16.2779 10.5667 15.9943 10.5667 15.6446C10.5667 15.2948 10.8502 15.0112 11.2 15.0112C11.5498 15.0112 11.8333 15.2948 11.8333 15.6446Z",
    fill: "#FF8833"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 2.5C5.5 1.94771 5.94772 1.5 6.5 1.5H17.1667C17.719 1.5 18.1667 1.94772 18.1667 2.5V3.45556C18.1667 4.00784 17.719 4.45556 17.1667 4.45556H6.5C5.94772 4.45556 5.5 4.00784 5.5 3.45556V2.5Z",
    fill: "#FF8833"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 18.5447C5.5 17.9924 5.94772 17.5447 6.5 17.5447H17.1667C17.719 17.5447 18.1667 17.9924 18.1667 18.5447V19.5002C18.1667 20.0525 17.719 20.5002 17.1667 20.5002H6.5C5.94772 20.5002 5.5 20.0525 5.5 19.5002V18.5447Z",
    fill: "#FF8833"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.d676d1dcc0bee8893d9df9c4709d436f.svg";
export { ForwardRef as ReactComponent };